// import { useEffect, useMemo, useState } from 'react'
import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { getFocusDate } from 'pages/avia/calendar-range/lib/focusDate.ts'

import { DateRangePicker, IRange } from 'features/range-date/date-range-picker'

// import { prepareDate } from 'features/range-date/lib'
import findTicketFormStore from 'entities/beket/models/find-ticket/find-ticket-store.ts'

// import { AvailableSeats, SearchApiBeket } from 'shared/api/beket/search'
// import Loop from 'shared/images/glasss.png'
// import { addDate } from 'shared/lib/dateFormat'
// import { EmptyPage } from 'shared/ui/empty-page'
import { HeaderGoBack } from 'shared/ui/header-go-back'

// import { Loader } from 'shared/ui/loader'
import s from './styles.module.scss'

const firstIndex = 0
const isDifficult = true

function getNext7DaysFormatted() {
  const result = []
  const today = new Date()

  for (let i = 0; i < 7; i++) {
    const d = new Date(today)
    d.setDate(today.getDate() + i)

    const formatted = d.toISOString().split('T')[0]?.split('-').join('/')
    result.push(formatted)
  }

  return result
}

const BeketCalendarPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [params] = useSearchParams()
  const isSearch = params.get('page')

  // const [dates, setDates] = useState<AvailableSeats[]>([])
  // const [loading, setLoading] = useState<boolean>(false)

  const directions = !!isSearch
    ? findTicketFormStore?.getFormFindTicketDirectionsCopy()
    : findTicketFormStore?.getFormFindTicketDirections()

  // const availableSeats = findTicketFormStore?.getCountOfPassengers()
  const currentDirection = directions?.[firstIndex]

  // focus only on open: confirming updates the store, and refocusing would
  // start a smooth window scroll that continues on the page we navigate back to
  const [focusDate] = useState(() =>
    directions?.length ? getFocusDate(directions, !isDifficult) : undefined,
  )

  const onDateHandler = (data: IRange) => {
    findTicketFormStore.onSetRangeDate({
      rangeData: data,
      indexDirect: firstIndex,
      isCopy: !!isSearch,
    })

    navigate(-1)
  }

  // const getAvailableSeats = async () => {
  //   if (!!currentDirection?.from?.id && !!currentDirection?.to?.id) {
  //     try {
  //       const params = {
  //         arrival_city: currentDirection?.to?.id,
  //         departure_city: currentDirection?.from?.id,
  //         available_seats: availableSeats,
  //       }

  //       if (!currentDirection?.from?.id || !currentDirection?.to?.id) return

  //       setLoading(true)

  //       const response = await SearchApiBeket.searchCalendarFreeSeats(params)

  //       setDates(response?.data?.data)
  //     } catch {
  //       setDates([])
  //     } finally {
  //       setLoading(false)
  //     }
  //   }
  // }

  const activeDays = getNext7DaysFormatted()
  //  useMemo(
  //   () => dates?.map((item) => prepareDate(item.departure_date)),
  //   [dates],
  // )

  const selectedDate: IRange = {
    startDate: currentDirection?.date || '',
  }

  // useEffect(() => {
  //   void getAvailableSeats()
  // }, [])

  return (
    <div className={s.container}>
      <div className={s.header}>
        <HeaderGoBack
          variant={'grey'}
          title={t('beket.page.choose_date')}
          buttonWhite
        />
      </div>
      {/* {loading && <Loader marginTop={150} />} */}

      {/* {!loading &&
        (!activeDays.length ? (
          <div className={s.empty}>
            <EmptyPage
              title={t('beket_content.empty_list_title')}
              subTitle={t('beket_content.empty_list_description')}
              image={Loop}
            />
          </div>
        ) : ( */}
      <div className={s.contentPop}>
        <DateRangePicker
          difficult
          maxMonth={2}
          focusDate={focusDate}
          indexDirection={firstIndex}
          selectedDate={selectedDate}
          onChange={onDateHandler}
          typeCalendar="beket"
          activeDays={activeDays}
        />
      </div>
      {/* ))} */}
    </div>
  )
})

export default BeketCalendarPage
